import {
  useAddProgramMutation,
  useGetProgramsByOrgLazyQuery,
} from "graphql/__generated__/hooks";
import { Program } from "graphql/__generated__/schemas";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

export const useProgramOrganization = () => {
  const { organizationId } = useParams();
  const [addProgram] = useAddProgramMutation();
  const [getProgramsByOrg, { data: programData }] =
    useGetProgramsByOrgLazyQuery();

  const program = useMemo(() => {
    const programs = (programData?.program as Program[]) || [];
    if (programs.length > 0) {
      return programs[0];
    } else {
      return null;
    }
  }, [programData]);

  useEffect(() => {
    if (organizationId) {
      getProgramsByOrg({ variables: { orgId: organizationId } });
    }
  }, [organizationId]);

  useEffect(() => {
    // Added a program if not exists for the selected organization
    if (programData?.program.length === 0) {
      addProgram({ variables: { orgId: organizationId } }).then((res) => {
        getProgramsByOrg({ variables: { orgId: organizationId } });
      });
    }
  }, [programData]);

  return { organizationId, program };
};
